import ModuleCreate from "../components/ModuleCreate";
import {ROUTE_MODULES, ROUTE_MODULES_DETAIL} from "../routes";
import {push} from "react-router-redux";
import {connect} from "react-redux";
import {isProcessing} from "../actions/processingActions";
import {PROC_MODULES_UPDATE} from "../actions";
import {createModule} from "../actions/moduleActions";
import {showSnackbar} from "../actions/snachbarActions";

const m2s = state => ({
	topSaveButton: false,
	isLoading: isProcessing(state, PROC_MODULES_UPDATE)
});
const m2d = dispatch => ({
	onCreate: (module, onSuccess) => dispatch(createModule(module, result => {
		onSuccess && onSuccess(result);
		dispatch(showSnackbar('snackbar.modules.created'));
		dispatch(push(ROUTE_MODULES_DETAIL.replace(':module_id', result.module.module_id)));
	})),
	onBack: () => dispatch(push(ROUTE_MODULES))
});

export default connect(m2s, m2d)(ModuleCreate);


// WEBPACK FOOTER //
// ./src/containers/ModuleCreateController.js